//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Clearance",1,0],[1,"Clearance1",0,"Expression",0],[1,"Clearance2",0,"Expression",0],[1,"Clearance3",0,"Expression",0],[1,"Clearance4",0,"Expression",0],[1,"Clearance5",0,"Expression",0],[1,"Clearance6",0,"Expression",0],[1,"Clearance7",0,"Expression",0],[1,"CopyRelief",0,"SelectBodyList",0],[0,"CreateEditMethod",1,0],[0,"CreateLocation",1,0],[1,"CurveSuperSelect",0,"Section",0],[0,"DeleteMethod",1,0],[0,"HideReliefStatus",1,0],[0,"NumberOfCopy",1,0],[0,"Pitch",1,0],[0,"PositionPrecisionValue",1,0],[0,"PrecisionValue",1,0],[1,"ReliefFace",0,"ScCollector",0],[1,"ReliefHeight",0,"Expression",0],[1,"ReliefRadius",0,"Expression",0],[1,"ReliefStart",0,"Expression",0],[1,"SelectionReliefToEdit",0,"SelectNXObject",0],[0,"Type",1,0],[0,"UdfOffset",1,0],[0,"UseNonAlignedMinimumBox",1,0]],[[["faceOccs"],"SetFaces",{},1,0],[[],"WaveFaces",{},0,0],[[],"DeleteLinkedFace",{},0,0]],[]];
SPLM.Tooling.ReliefDesignBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ReliefDesignBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ReliefDesignBuilder.Types = Object.freeze({
    "Create" : "Create", "Edit" : "Edit", "Copy" : "Copy", "Delete" : "Delete"});

SPLM.Tooling.ReliefDesignBuilder.Method = Object.freeze({
    "BBox" : "BBox", "BoundCylinder" : "BoundCylinder", "UDef" : "UDef"});

SPLM.Tooling.ReliefDesignBuilder.MethodOfDelete = Object.freeze({
    "DeleteSelectedInstance" : "DeleteSelectedInstance", "DeleteAllInstances" : "DeleteAllInstances"});

export default SPLM;